import { createAction } from '@reduxjs/toolkit';
import { createActionWithCallback } from 'core/store/utils';
import { RequestError, User, UserModifyInfo, UserParams } from 'types';

export const createUser = createActionWithCallback<void, Error>()('user/create', (user: UserParams) => ({
  payload: user,
}));

export const createdUser = createAction('user/created', (error?: RequestError) => ({
  payload: error,
  error: Boolean(error),
}));

export const updateUser = createActionWithCallback<void, Error>()('user/update', (user: User) => ({
  payload: user,
}));

export const updatedUser = createAction('user/updated', (error?: RequestError, data?: UserModifyInfo) => ({
  payload: error || data,
  error: Boolean(error),
}));

export const deleteUser = createActionWithCallback<void, Error>()('user/delete', (payload: { id: string }) => ({
  payload,
}));

export const deletedUser = createAction('user/deleteded', (error?: RequestError) => ({
  payload: error,
  error: Boolean(error),
}));

export default {
  createdUser,
  createUser,
  updatedUser,
  updateUser,
  deleteUser,
  deletedUser,
};
